<fcp-dropdown-tree
    [title]="'ORDER.PRODUCT_SEARCH.FILTER_SIZE_TITLE' | translate"
    searchTitle="{{ 'ORDER.PRODUCT_SEARCH.FILTER_SIZE_SEARCH' | translate }}"
    [menu]="detailedSizesFilter | async"
    [isMulti]="true"
    notFoundMessage="{{ 'ORDER.PRODUCT_SEARCH.FILTER_SIZE_EMPTY' | translate }}"
    [allowSearch]="true"
    (itemSelected)="handleOnSelectDetailedSizeFilter($event)"
    [selectedItemValue]="sizesFilterValue | async"
    [disabled]="disabled"
>
</fcp-dropdown-tree>
